export default __webpack_public_path__ + "static/media/wc.7d55c21b.png";